import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Loader2, Mail, CheckCircle, XCircle } from "lucide-react";

const TestEmailSend = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);

  const handleTestEmail = async () => {
    setLoading(true);
    setResult(null);
    
    try {
      console.log("🚀 Invoking send-weekly-token-reminder function...");
      
      const { data, error } = await supabase.functions.invoke('send-weekly-token-reminder', {
        body: {}
      });

      if (error) {
        console.error("❌ Error:", error);
        toast.error("Failed to send emails: " + error.message);
        setResult({ success: false, error: error.message });
      } else {
        console.log("✅ Success:", data);
        toast.success("Email function executed successfully!");
        setResult(data);
      }
    } catch (err: any) {
      console.error("❌ Exception:", err);
      toast.error("Error: " + err.message);
      setResult({ success: false, error: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container max-w-2xl mx-auto py-8 px-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Mail className="w-6 h-6" />
            Test Weekly Token Reminder Emails
          </CardTitle>
          <CardDescription>
            Click the button below to manually trigger the weekly token reminder email function.
            This will send emails to all students with 0 tokens.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button 
            onClick={handleTestEmail} 
            disabled={loading}
            className="w-full"
            size="lg"
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Sending Emails...
              </>
            ) : (
              <>
                <Mail className="w-4 h-4 mr-2" />
                Send Test Emails Now
              </>
            )}
          </Button>

          {result && (
            <Card className={result.success ? "border-green-500" : "border-red-500"}>
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg">
                  {result.success ? (
                    <>
                      <CheckCircle className="w-5 h-5 text-green-500" />
                      Success
                    </>
                  ) : (
                    <>
                      <XCircle className="w-5 h-5 text-red-500" />
                      Error
                    </>
                  )}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <pre className="bg-muted p-4 rounded-lg overflow-auto text-sm">
                  {JSON.stringify(result, null, 2)}
                </pre>
              </CardContent>
            </Card>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default TestEmailSend;
